<iframe #frmGenerali style="width: 0px; height: 0px; border: none;"></iframe>
<div class="grid">
    
    <div class="col-12 pt-0">

        <div id="case-header" class="card-general-data mb-2">
            
            <p-accordion #accordionDetailsTab class="w-full" (onOpen)="onGeneralDataOpen()">
                <p-accordionTab [selected]="true">
                    <ng-template pTemplate="header">
                        <div class="w-full flex justify-content-center align-items-center pb-0 gap-2">
                            <div class="p-card-title">Datos generales</div>
                            <div class="flex-grow-1"></div>
                            <p-badge *ngIf="case.isRecapture" value="Reapertura" severity="warn" />
                            <p-badge *ngIf="case.isVIP" value="VIP" severity="danger" />
                            <p-badge *ngIf="case.isUrgent" value="Urgente" severity="danger" />
                            <p-badge *ngIf="case.isPrecite" value="Precita" severity="danger" />
                            <p-button *ngIf="allowWrite" label="Cerrar expediente" severity="warn" icon="pi pi-lock" [disabled]="case.caseState?.code=='ECONOMIC_REVIEW'" [pTooltip]="case.caseState?.code=='ECONOMIC_REVIEW' ? 'No se puede finalizar hasta que se marque Ok, revisado' : ''" (click)="changeCaseStatusModal($event, case, true)" />
                            <p-button *ngIf="case.caseState?.code=='ECONOMIC_REVIEW' && loginService.hasPermission('CASES.PROFIT_REVIEW')" label="Ok, revisado" severity="success" icon="pi pi-check" (click)="acknowledgeProfitReview($event)" />
                            <p-button *ngIf="loginService.hasPermission('CASES.AI_RESUME')" label="Resumen" [severity]="hasCaseResume ? 'info' : 'secondary'" icon="pi pi-microchip-ai" (click)="resumeCase($event, case)" />
                            <p-button *ngIf="loginService.hasPermission('CASES.AI_AGENTS')" label="Videoperitación" [severity]="hasCaseAgentInforme ? 'success' : 'secondary'" icon="pi pi-video" (click)="openCaseVideoModal($event, case)" />
                            <p-button *ngIf="allowWrite" label="Enviar comunicación" severity="secondary" icon="pi pi-envelope" (click)="addComunication($event, null, null, null)" />
                            <p-button *ngIf="allowAssignProcessor" label="Asignar tramitador" severity="secondary" icon="pi pi-user-edit" (click)="editProcessor($event)" />
                            <p-button icon="pi pi-info-circle" (click)="openDeclarationModal($event)" onlyIcon="true" p-tooltip="Declaración de siniestro" />
                            <p-button *ngIf="case.contract?.integration?.code=='GENERALI'" label="Abrir generali" icon="pi pi-external-link" (click)="openGenerali($event)" />
                            <p-button label="Editar" icon="pi pi-pencil" (click)="editGeneral($event)" />
                            <p-button icon="pi pi-align-justify" onlyIcon="true" p-tooltip="Opciones" (click)="optionsSidebarVisible = true" />
                        </div>
                    </ng-template>
                

                    <div *ngIf="AIGeneratedJobs>0" class="headerInfo">
                        <p-messages severity="success" [closable]="false" >
                            <ng-template pTemplate>
                                <i class="pi pi-microchip-ai mr-2"></i> {{AIGeneratedJobsMessage}}
                            </ng-template>
                        </p-messages>
                    </div>
                    <div *ngIf="postalCodeNotInZonesFromCompany" class="headerInfo">
                        <p-messages severity="error" [closable]="false" >
                            <ng-template pTemplate>
                                Esta zona no está en el contrato de la compañía.
                            </ng-template>
                        </p-messages>
                    </div>
                    <div *ngIf="messageGuarantee" class="headerInfo">
                        <p-messages severity="warn" [closable]="false" >
                            <ng-template pTemplate>
                                {{messageGuarantee}}
                            </ng-template>
                        </p-messages>
                    </div>
                    
                    <div class="grid">
                        <div class="col-2">
                            <strong>Id Expediente</strong>
                            <div class="mt-2">{{case.caseNumber}} <span class="text-muted" *ngIf="case.caseNumberSecondary">({{case.caseNumberSecondary}})</span></div>
                        </div>
                        <div class="col-2">
                            <strong>Fecha de apertura</strong>
                            <div class="mt-2">{{case.caseDate | date: 'dd/MM/yyyy HH:mm'}}</div>
                            <small *ngIf="case.recaptureDate">R: {{case.recaptureDate | date: 'dd/MM/yyyy HH:mm'}}</small>
                        </div>
                        <div class="col-2">
                            <strong>Tramitador</strong>
                            <div *ngIf="!allowAssignProcessor" class="mt-2" [ngClass]="case.processor?.absence ? 'text-danger' : ''">{{case.processor?.name}}</div>
                            <div *ngIf="allowAssignProcessor" class="input-field">
                                <p-dropdown [(ngModel)]="case.processorId" [options]="processors" optionLabel="name" optionValue="id" appendTo="body"
                                    [filter]="true" filterBy="name" (onChange)="changeProcessor()" d-form-field-error>
                                    <ng-template pTemplate="selectedItem">
                                        <div *ngIf="case.processorId" [ngClass]="getSelectedProcessor()?.absence ? 'text-danger' : ''">
                                            {{getSelectedProcessor()?.name}}
                                        </div>
                                    </ng-template>
                                    <ng-template let-processor pTemplate="item">
                                        <div [ngClass]="processor?.absence ? 'text-danger' : ''">
                                            {{processor.name}}
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Sociedad</strong>
                            <div class="mt-2">{{case.contract?.business?.name}}</div>
                        </div>                          
                        <div class="col-2">
                            <strong>Estado</strong>
                            <div class="input-field">
                                <p-dropdown [(ngModel)]="case.caseStateId" [options]="caseStates" optionLabel="name" optionValue="id" appendTo="body"
                                    [filter]="true" filterBy="name" (onChange)="changeCaseState()" d-form-field-error>
                                    <ng-template pTemplate="selectedItem">
                                        <div class="flex align-items-center gap-1" *ngIf="case.caseStateId">
                                            <i class="pi pi-circle-fill" [style.color]="getSelectedCaseState()?.backgroundColor"></i>{{getSelectedCaseState()?.name}}
                                        </div>
                                    </ng-template>
                                    <ng-template let-caseState pTemplate="item">
                                        <div class="flex align-items-center gap-1">
                                            <i class="pi pi-circle-fill" [style.color]="caseState.backgroundColor"></i>{{caseState.name}}
                                        </div>
                                    </ng-template>
                                </p-dropdown>
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Fecha de revisión</strong>
                            <div class="mt-2">
                                <a *ngIf="case.revisionDate!= null" (click)="showModal()"  class="p-button-link" style="justify-content: start;"><i
                                    class="pi pi-calendar"></i> {{case.revisionDate | date:'dd/MM/yyyy'}}</a>
                                <a *ngIf="case.revisionDate==null" (click)="showModal()"   class="p-button-link" style="justify-content: start;"><i
                                class="pi pi-calendar"></i> Añadir fecha</a>
                            </div>
                        </div>
                        <div class="col-12 border-1 description-info border-round" *ngIf="cancelReasonDescription">
                            <strong>Descripción de la anulación</strong>
                            <div class="mt-2">{{cancelReasonDescription}}</div>
                        </div>
                        <div class="col-2">
                            <strong>Referencia</strong>
                            <div class="mt-2">{{case.reference}}</div>
                        </div>
                        <div class="col-2">
                            <strong>Compañía</strong>
                            <div class="mt-2">{{case.company?.name}}</div>
                            <div class="">
                                <a *ngIf="case.company?.phone1" (click)="showPhoneOverlayPanel($event, case.company?.phone1, case.company?.name)" [class.text-bold]="case.company?.priorityPhone==1" class="p-button-link justify-content-start"><i
                                        class="pi pi-phone"></i> {{case.company?.phone1}}<span *ngIf="case.company?.phone1Description">({{case.company?.phone1Description}})</span></a>                                    
                                <a *ngIf="case.company?.phone2" (click)="showPhoneOverlayPanel($event, case.company?.phone2, case.company?.name)" [class.text-bold]="case.company?.priorityPhone==2" class="p-button-link justify-content-start"><i
                                        class="pi pi-phone"></i> {{case.company?.phone2}}<span *ngIf="case.company?.phone2Description">({{case.company?.phone2Description}})</span></a>       
                                <a *ngIf="case.company?.phone3" (click)="showPhoneOverlayPanel($event, case.company?.phone3, case.company?.name)" [class.text-bold]="case.company?.priorityPhone==3" class="p-button-link justify-content-start"><i
                                        class="pi pi-phone"></i> {{case.company?.phone3}}<span *ngIf="case.company?.phone3Description">({{case.company?.phone3Description}})</span></a>   
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Contrato</strong>
                            <div class="mt-2">{{case.contract?.name}}</div>
                            <div class="flex gap-2" *ngFor="let contractOutboundPhone of contractOutboundPhones">
                                <a (click)="showPhoneOverlayPanel($event, contractOutboundPhone.phone, case.contract?.name)" class="p-button-link justify-content-start">
                                    <i class="pi pi-phone"></i> {{contractOutboundPhone.phone}}
                                    <span *ngIf="contractOutboundPhone.description">({{contractOutboundPhone.description}})</span>
                                </a>
                                
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Tipo de daño</strong>                        
                            <div class="mt-2">
                                <i pTooltip="Indique el tipo de daño" class="pi pi-info-circle text-danger" *ngIf="!case.caseType"></i>
                                {{(case.caseType!=null?case.caseType?.name:'Sin definir')}}
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Número de aviso</strong>
                            <div class="mt-2 flex flex-wrap gap-2" *ngIf="caseNotificationNumbers?.length">
                                <span *ngFor="let notificationNumber of caseNotificationNumbers" [pTooltip]="notificationNumber.displayInfo" tooltipPosition="top">{{notificationNumber.code}}</span>
                            </div>
                            <div *ngIf="caseNotificationNumbers?.length==0">{{case.notificationNumber}}</div>
                        </div>
                        <div class="col-2">
                            <strong>Gremio</strong>
                            <div class="mt-2">{{case.capabilityDescription}}</div>
                        </div>
                        <div class="col-6">
                            <strong>Asegurado</strong>
                            <div class="mt-2 flex gap-4 align-items-center">
                                <span>{{case.client?.name}} 
                                    <br>
                                    <span *ngIf="case.client?.vatNumber">{{case.client?.vatNumber}}</span>
                                    <span *ngIf="!case.client?.vatNumber" style="color: red">(SIN DNI)</span>
                                </span>
                                <span *ngIf="case.client?.clientSubType!=null">({{case.client?.clientSubType?.name}})</span>
                                <span class="flex align-items-center gap-1">
                                    <i pTooltip="Faltan datos en la dirección" class="pi pi-info-circle text-danger" *ngIf="!case.address || !case.address?.zipCode || !case.address?.city || !case.address?.countryRegionId"></i>
                                    {{case.address?.fullAddress}}
                                </span>
                                <a *ngIf="case.client?.phone1" (click)="showPhoneOverlayPanel($event, case.client?.phone1, case.client?.name)" class="p-button-link" [class.text-bold]="case.client?.priorityPhone==1"><i
                                    class="pi pi-phone"></i> {{case.client?.phone1}} <span *ngIf="case.client?.phone1Description">({{case.client?.phone1Description}})</span></a>
                                <a *ngIf="case.client?.phone2" (click)="showPhoneOverlayPanel($event, case.client?.phone2, case.client?.name)" class="p-button-link" [class.text-bold]="case.client?.priorityPhone==2"><i
                                    class="pi pi-phone"></i> {{case.client?.phone2}} <span *ngIf="case.client?.phone2Description">({{case.client?.phone2Description}})</span></a>
                                <a *ngIf="case.client?.phone3" (click)="showPhoneOverlayPanel($event, case.client?.phone3, case.client?.name)" class="p-button-link" [class.text-bold]="case.client?.priorityPhone==3"><i
                                    class="pi pi-phone"></i> {{case.client?.phone3}} <span *ngIf="case.client?.phone3Description">({{case.client?.phone3Description}})</span></a>
                                <a *ngIf="case.client?.email" (click)="mail(case.client?.email, null, null, false)" class="p-button-link"><i
                                        class="pi pi-envelope"></i>{{case.client?.email}}</a>
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Centro ciudad</strong>
                            <div class="mt-2 flex gap-4" [ngClass]="{'text-danger':distanceToCityCenter!=null && distanceToCityCenter==0}">                            
                                {{distanceToCityCenter | number:'1.0-2' }}km
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Póliza</strong>
                            <div class="mt-2 flex gap-4">                            
                                <a (click)="editClientPolicy(case.clientPolicy?.id!)" class="p-button-link" style="display: inline;">
                                    {{case.clientPolicy?.displayName}}
                                    <span *ngIf="case.clientPolicy?.franchisePrice!=null" class="text-danger"> - Franquicia {{case.clientPolicy?.franchisePrice | currency:'EUR':true}}</span>
                                </a>                                                        
                            </div>
                        </div>
                        <div class="col-2">
                            <strong>Tratamiento</strong>
                            <div class="mt-2">
                                <span class="p-tag" 
                                    [style.backgroundColor]="case.caseTreatment?.backgroundColor"
                                    [style.color]="case.caseTreatment?.foregroundColor">
                                    <icon class="pi mr-1" [ngClass]="case.caseTreatment?.icon"></icon>
                                    <span class="p-tag-label">{{case.caseTreatment?.name}}</span>
                                </span>
                            </div>
                        </div>
                        <div class="col-12" *ngIf="totalAffecteds.length>0">
                            <strong>Implicados</strong>
                            <div class="mt-2 flex gap-4 align-items-center" *ngFor="let affected of totalAffecteds">                            
                                <span>{{affected.name}} ({{affectedPartyTypeLabel(affected.partyType)}})</span>
                                <span class="flex align-items-center gap-1">
                                    {{affected.address?.fullAddress}}
                                </span>
                                <a *ngIf="affected.phone1" (click)="showPhoneOverlayPanel($event, affected.phone1, affected.name)" class="p-button-link"><i
                                        class="pi pi-phone"></i> {{affected.phone1}}</a>                                    
                                <a *ngIf="affected.phone2" (click)="showPhoneOverlayPanel($event, affected.phone2, affected.name)" class="p-button-link"><i
                                        class="pi pi-phone"></i> {{affected.phone2}}</a>
                                <a *ngIf="affected.email" (click)="mail(affected.email, null, null, false)" class="p-button-link"><i
                                        class="pi pi-envelope"></i>{{affected.email}}</a>
                            </div>
                        </div> 
                        <div class="col-12" *ngIf="countExperts>0">
                            <strong>Perito activo</strong>
                            <div class="mt-2 flex gap-4 align-items-center" *ngFor="let expert of caseExpertsHeader">                            
                                <span>{{expert.expert.name}}</span>
                                <span class="flex align-items-center gap-1">
                                    {{expert.expert.address?.fullAddress}}
                                </span>
                                <a *ngIf="expert.expert.phone1" (click)="showPhoneOverlayPanel($event, expert.expert.phone1, expert.expert.name)" class="p-button-link"><i
                                        class="pi pi-phone"></i> {{expert.expert.phone1}}</a>                                    
                                <a *ngIf="expert.expert.phone2" (click)="showPhoneOverlayPanel($event, expert.expert.phone2, expert.expert.name)" class="p-button-link"><i
                                        class="pi pi-phone"></i> {{expert.expert.phone2}}</a>
                                <a *ngIf="expert.expert.email" (click)="mail(expert.expert.email, null, null, false)" class="p-button-link"><i
                                        class="pi pi-envelope"></i>{{expert.expert.email}}</a>
                            </div>
                        </div>  
                        <div class="col-12" *ngIf="countMediators>0">
                            <strong>Mediador activo</strong>
                            <div class="mt-2 flex gap-4 align-items-center" *ngFor="let mediator of caseMediatorsHeader">                            
                                <span>{{mediator.mediator.name}}</span>
                                <span class="flex align-items-center gap-1">
                                    {{mediator.mediator.address?.fullAddress}}
                                </span>
                                <a *ngIf="mediator.mediator.phone1" (click)="showPhoneOverlayPanel($event, mediator.mediator.phone1, mediator.mediator.name)" class="p-button-link"><i
                                        class="pi pi-phone"></i> {{mediator.mediator.phone1}}</a>                                    
                                <a *ngIf="mediator.mediator.phone2" (click)="showPhoneOverlayPanel($event, mediator.mediator.phone2, mediator.mediator.name)" class="p-button-link"><i
                                        class="pi pi-phone"></i> {{mediator.mediator.phone2}}</a>
                                <a *ngIf="mediator.mediator.email" (click)="mail(mediator.mediator.email, null, null, false)" class="p-button-link"><i
                                        class="pi pi-envelope"></i>{{mediator.mediator.email}}</a>
                            </div>
                        </div>                    
                        <div class="col-12">
                            <strong>Descripción</strong>
                            <div class="mt-2">{{case.description}}</div>
                        </div>
                        <div class="col-12"  [ngClass]="{ 'border-1 description-info border-round ': case.notes }">
                            <strong>Observaciones</strong>
                            <ng-container *ngIf="case.notes; else noObs">
                                <ng-container *ngIf="parseObservaciones(case.notes) as obs">
                                    <div class="mt-2" *ngIf="obs.other" [innerText]="obs.other"></div>
                                    <!-- 1 aviso de ubicación: inline; ≥2: el más reciente + desplegable con el resto -->
                                    <div class="mt-2" *ngIf="obs.mismatches.length === 1" style="white-space: pre-wrap;" [innerText]="obs.mismatches[0]"></div>
                                    <ng-container *ngIf="obs.mismatches.length > 1">
                                        <div class="mt-2" style="white-space: pre-wrap;" [innerText]="obs.mismatches[obs.mismatches.length - 1]"></div>
                                        <a class="mt-2 inline-block cursor-pointer text-primary" (click)="showAllLocationMismatches = !showAllLocationMismatches">
                                            <i class="pi" [ngClass]="showAllLocationMismatches ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                                            {{ showAllLocationMismatches ? 'Ocultar avisos anteriores' : ('Ver ' + (obs.mismatches.length - 1) + ' aviso(s) de ubicación anteriores') }}
                                        </a>
                                        <div *ngIf="showAllLocationMismatches">
                                            <div class="mt-2" *ngFor="let m of obs.mismatches.slice(0, obs.mismatches.length - 1)" style="white-space: pre-wrap;" [innerText]="m"></div>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-template #noObs>
                                <div class="mt-2"><i>No hay observaciones</i></div>
                            </ng-template>
                        </div>

                        <div class="col-12">
                            <div class="flex gap-2">
                                <strong>
                                    Números de servicio relacionados
                                </strong>
                                <a (click)="editCaseNotificationNumber({})" class="p-button-link" pTooltip="Añadir" pTooltipPosition="top"><i class="pi pi-plus-circle"></i></a>
                                <a (click)="updateCaseNotificationNumber()" class="p-button-link" pTooltip="Recargar información de números de servicios" pTooltipPosition="top"><i class="pi pi-refresh"></i> Recargar</a>
                            </div>
                            <div class="mt-2">
                                <p-table *ngIf="caseNotificationNumbers.length > 0" [value]="caseNotificationNumbers">
                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th pSortableColumn="code" width="120" class="pt-2 pb-2">Nº de servicio <p-sortIcon field="code"></p-sortIcon></th>
                                            <th pSortableColumn="date" width="200" class="pt-2 pb-2">Fecha <p-sortIcon field="date"></p-sortIcon> </th>
                                            <th pSortableColumn="capabilityDescription" width="300" class="pt-2 pb-2">Gremio<p-sortIcon field="capabilityDescription"></p-sortIcon></th>
                                            <th pSortableColumn="description" class="pt-2 pb-2">Descripción <p-sortIcon field="description"></p-sortIcon></th>
                                            <th pSortableColumn="state" width="200" class="pt-2 pb-2">Estado <p-sortIcon field="state"></p-sortIcon></th>
                                            <th width="80"></th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-service>
                                        <tr>
                                            <td>{{service.code}}</td>
                                            <td>{{service.date | date: 'dd/MM/yyyy HH:mm:ss'}}</td>
                                            <td>{{service.capabilityDescription}}</td>
                                            <td>{{service.description}}</td>
                                            <td>{{service.state}}</td>
                                            <td>
                                                <div class="flex gap-2">
                                                    <a (click)="editCaseNotificationNumber(service)" pTooltip="Editar" pTooltipPosition="top"><i class="pi pi-pencil"></i></a>
                                                    <a *ngIf="case.contract?.integration?.code=='MULTI'" (click)="openMulti($event, service.code)" pTooltip="Abrir en Multi" pTooltipPosition="top"><i class="pi pi-external-link"></i></a>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                                <i *ngIf="caseNotificationNumbers.length==0">No se han encontrado números de servicio relacionados</i>
                            </div>
                        </div>

                        <div class="col-12">
                            <strong>Tipos de servicios</strong>
                            <div class="mt-2 flex gap-2 " *ngIf="servicesTypes.length>0">
                                <div *ngFor="let serviceTypeCompany of servicesTypes">
                                    <label class="inline-flex align-items-center gap-2 cursor-pointer" *ngIf="serviceTypeCompany.serviceType!=null"><p-checkbox [(ngModel)]="selectedServiceTypes" name="capability"
                                    [value]="serviceTypeCompany.serviceTypeId" (onChange)="saveServiceTypeCase($event)" />{{ serviceTypeCompany?.serviceType?.name }}</label>
                                </div>
                            </div>
                            <div class="mt-2" *ngIf="servicesTypes.length == 0">
                                No hay tipos de servicio asignados a este expediente.
                            </div>
                        </div>
                    </div>
                    

                <!--</p-card>-->
                </p-accordionTab>
            </p-accordion>
        </div>

        <p-sidebar [(visible)]="optionsSidebarVisible" position="right" styleClass="cases-options-sidebar" [appendTo]="'body'">
            <div class="cases-sidebar-menu">
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(0)"><i class="pi pi-calendar"></i><span>Citas</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(1)"><i class="pi pi-bell"></i><span>Eventos</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(2)"><i class="pi pi-briefcase"></i><span>Trabajos</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(3)"><i class="pi pi-money-bill"></i><span>Presupuestos</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(4)"><i class="pi pi-paperclip"></i><span>Adjuntos</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(5)"><i class="pi pi-users"></i><span>Implicados</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(6)"><i class="pi pi-user-edit"></i><span>Peritos</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(7)"><i class="pi pi-wrench"></i><span>Técnicos</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(8)"><i class="pi pi-users"></i><span>Mediadores</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(9)"><i class="pi pi-file"></i><span>Notas</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(10)"><i class="pi pi-inbox"></i><span>Solicitudes</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(11)"><i class="pi pi-exclamation-circle"></i><span>Incidencias</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(12)"><i class="pi pi-comments"></i><span>Consultas/Reclamaciones</span></button>
                <button type="button" class="cases-sidebar-menu-item" (click)="goToAccordionTabFromSidebar(13)"><i class="pi pi-refresh"></i><span>Devoluciones</span></button>
            </div>
        </p-sidebar>
        
        <a *ngIf="relatedCasesCount>0" [href]="relatedCasesLink" target="_blank" style="text-decoration: none;">
            <p-messages severity="info" styleClass="related-cases-message">
                <ng-template pTemplate>
                    {{relatedCasesMessage}}
                </ng-template>
            </p-messages>
        </a>

        <p-messages severity="error" *ngIf="otherUserConnected!=null">
            <ng-template pTemplate>
                El usuario {{otherUserConnected.name}} ha estado conectado a este expediente. Última conexión {{ case.lastConnectedUserDate | date: 'dd/MM/yyyy HH:mm:ss'}}.
            </ng-template>
        </p-messages>

        <!--<a *ngIf="casesSamePolicyAndNotificationNumber.length>0" [href]="'cases?clientPolicy='+case.clientPolicy?.policyNumber+'&notificationNumber='+case.notificationNumber" target="_blank" style="text-decoration: none;">
            <p-messages severity="info">
                <ng-template pTemplate>
                    Existen otros expedientes registrados para el número de poliza {{case.clientPolicy?.policyNumber}} y número de aviso {{case.notificationNumber}}.
                </ng-template>
            </p-messages>
        </a>-->

        
        
        
        <p-accordion id="accordion-tabs" #accordionTabs [multiple]="true" (onOpen)="onTabChange($event)">
            <p-accordionTab id="accordion-tab-citas" [selected]="true" *ngIf="allowAccessCaseServices">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Citas</span>
                        <div class="flex-grow-1"></div>
                        <p-tag severity="secondary" *ngIf="totalServicesRecords>0"  value="{{totalServicesRecords}} citas" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>

                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir cita" styleClass="ml-2" icon="pi pi-plus" (click)="editService(null)" />
                </div>

                <p-table #grid [value]="caseServices" [loading]="loadingServices" [paginator]="true" [rows]="25"
                    [totalRecords]="totalServicesRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[25,50,100]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="date" width="120">Fecha/Hora <p-sortIcon field="date"></p-sortIcon> </th>
                            <th pSortableColumn="workerId">Operario <p-sortIcon field="workerId"></p-sortIcon></th>
                            <th pSortableColumn="capability.name" width="250">Especialidad<p-sortIcon field="capability.name"></p-sortIcon></th>
                            <th pSortableColumn="isUrgent" width="80">Urgente <p-sortIcon field="isUrgent"></p-sortIcon></th>
                            <th pSortableColumn="dateStart" width="120">Inicio <p-sortIcon field="dateStart"></p-sortIcon></th>
                            <th pSortableColumn="dateEnd" width="120">Fin <p-sortIcon field="dateEnd"></p-sortIcon></th>
                            <th pSortableColumn="dateStart" width="90">Estado</th>
                            <th pSortableColumn="isConfirmed" width="90">Confirmada</th>
                            <th pSortableColumn="isValidated" width="90">Validada</th>
                            <th>Archivo</th>
                            <th width="120"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-service let-columns="columns">
                        <tr (dblclick)="editCaseService(service)">
                            <td >
                                <div class="flex align-items-center gap-1">
                                    <i *ngIf="service.reclamationType!=null" class="pi pi-exclamation-triangle p-1 bg-warning text-white" [pTooltip]="(service.reclamationType=='Itself'?'Reclamación propia':'Reclamación ajena')"></i>
                                    <i *ngIf="!service.isGuard" class="pi pi-clock p-1" [pTooltip]="'Horario normal'"></i>
                                    <i *ngIf="service.isGuard" class="pi pi-clock p-1 bg-danger text-white" [pTooltip]="'Horario de guardia'"></i>
                                    <span [class.text-warning]="!service.isConfirmed" [pTooltip]="getServiceDateTooltip(service)" [tooltipStyleClass]="service.notes ? 'tooltip-md' : ''">{{service.date | date: 'dd/MM/yyyy HH:mm'}}</span>
                                </div>
                                
                                <p-tag *ngIf="service.isNotScheduled" severity="warn" value="Sin citar" />
                            </td>
                            <td>
                                <div>{{service.worker?.name}}  <a class="p-button-text" icon="pi pi-info-circle" href="workers/{{service.workerId}}" target="_blank" onlyIcon="true" p-tooltip="Ver información operario" ><i class="pi pi-info-circle"></i></a></div>
                                <div class="flex gap-2 align-items-center">
                                    <a *ngIf="service.worker?.phone1!=null" (click)="showPhoneOverlayPanel($event, service.worker?.phone1, service.worker?.name, service)"><i class="pi pi-phone"></i>{{service.worker?.phone1}}</a>
                                    <a *ngIf="service.worker?.phone2!=null" (click)="showPhoneOverlayPanel($event, service.worker?.phone2, service.worker?.name, service)"><i class="pi pi-phone"></i>{{service.worker?.phone2}}</a>
                                    <a *ngIf="service.worker?.email!=null" (click)="mail(service.worker?.email, case.id, service.id, false)"><i class="pi pi-envelope mr-1"></i>{{service.worker?.email}}</a>
                                </div>
                                <div *ngIf="service.clientSignatureDenied" class="text-danger mt-1">
                                    <small><b>Cliente ha reusado firmar:</b> {{service.clientSignatureDeniedReason}}</small>
                                </div>
                            </td>
                            <td>
                                <div>{{service.capability?.name}}</div>
                                <div *ngIf="service.equipment" class="text-danger"><small><b>Equipamiento: {{service.equipment.name}}</b></small></div>
                                <div *ngIf="service.isBudgetRequired" class="text-danger"><small><b>Presupuesto requerido</b></small></div>
                                <app-case-service-materials [materials]="service.materials"></app-case-service-materials>
                                <div *ngIf="service.caseNotificationNumberId"><small>Nº servicio: {{service.caseNotificationNumber?.code}} - {{service.caseNotificationNumber?.date | date: 'dd/MM/yyyy'}} - {{service.caseNotificationNumber?.capabilityDescription}}</small></div>
                            </td>
                            <td>
                                <p-tag *ngIf="!service.isUrgent" severity="info" value="Normal" />
                                <p-tag *ngIf="service.isUrgent" severity="danger" value="Urgente" />
                            </td>
                            <td>{{service.dateStart | date: 'dd/MM/yyyy HH:mm'}}</td>
                            <td>
                                {{service.dateEnd | date: 'dd/MM/yyyy HH:mm'}}
                            </td>
                            <td>
                                <p-tag *ngIf="isOnTime(service)" severity="warn"
                                    value="Pendiente" />
                                <p-tag *ngIf="isStarted(service)" severity="warn"
                                    value="En curso" />
                                <p-tag *ngIf="isEnded(service)" severity="success" value="Finalizado" />
                                <p-tag *ngIf="isCancelled(service)" severity="danger" value="Cancelada" 
                                        pTooltip="{{service.cancelCaseServiceCauseId ? service.cancelCaseServiceCause.name:''}} - {{service.cancelCaseServiceReasonId?service.cancelCaseServiceReason.name:service.cancelCaseServiceReasonNotes}}" />
                                <p-tag *ngIf="isRejected(service)" severity="danger" value="Rechazada"></p-tag>
                                <p-tag *ngIf="isFailed(service)" severity="danger" value="Fallida"></p-tag>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="service.isConfirmed" [binary]="true" [disabled]="true"></p-checkbox >
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="service.isValidated" [binary]="true" [disabled]="true"></p-checkbox >
                            </td>
                            <td>
                                <ul style="padding: 0px; margin:0px;    overflow-wrap: anywhere; width: 120px">
                                    <li *ngFor="let file of service.files">
                                            <a (click)="downloadFile(file.fileId)"><small [pTooltip]="file.notes">{{file.file.fileName}}</small></a>
                                    </li>
                                </ul>
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button (click)="printCaseServiceVisitPart(service)" [rounded]="true"
                                        [text]="false" severity="secondary">
                                        <i class="pi pi-print"></i></p-button>
                                    <p-button *ngIf="allowWrite" (click)="editCaseService(service)" [rounded]="true"
                                        [text]="false">
                                        <i class="pi pi-pencil"></i></p-button>
                                    <p-button (click)="openChat(service)" [rounded]="true" [text]="false">
                                        <i class="pi pi-comments"></i>
                                    </p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                          <td [attr.colspan]="10">        
                             No se han encontrado citas
                          </td>
                        </tr>
                      </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-eventos">

                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Eventos</span>
                        <div class="flex-grow-1"></div>
                        <span *ngIf="hasPendingLogs" class="p-tag p-tag-warn flex gap-2 align-items-center">
                            <span class="p-tag-label">Tienes comunicaciones pendientes</span>
                        </span>
                        <p-tag severity="secondary" *ngIf="countLogs>0"  value="{{countLogs}} eventos" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>
                <div class="flex gap-2 mb-2" style="align-items: center;">
                    <p-dropdown [(ngModel)]="caseLogsFilter.resourceType.value" [options]="caseLogResourceType" optionLabel="name"
                        optionValue="id" appendTo="body" placeholder="Seleccione tipo"
                        (onChange)="loadLogs(lastGridLogEvent)" showClear styleClass="sm"></p-dropdown>
                    <p-dropdown [(ngModel)]="caseLogsFilter.direction.value" [options]="caselogDirections" optionLabel="name"
                        optionValue="id" appendTo="body" placeholder="Seleccione dirección"
                        (onChange)="loadLogs(lastGridLogEvent)" showClear styleClass="sm"></p-dropdown>
                    <p-dropdown [(ngModel)]="caseLogsFilter.caseLogTypeId.value" [options]="caseLogTypes" optionLabel="name"
                        optionValue="id" appendTo="body" placeholder="Selecciona categoría"
                        (onChange)="loadLogs(lastGridLogEvent)" showClear styleClass="sm"></p-dropdown>
                    <p-dropdown [(ngModel)]="caseLogsFilter.caseNotificationNumberId.value" [options]="caseNotificationNumbers" optionLabel="displayInfo"
                        optionValue="id" appendTo="body" placeholder="Selecciona servicio relacionado"
                        (onChange)="loadLogs(lastGridLogEvent)" showClear styleClass="sm"></p-dropdown>
                    
                    <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="pendingLogs" [binary]="true" (onChange)="loadLogs(lastGridLogEvent)" />Eventos pendientes</label>
                    <label class="inline-flex align-items-center gap-2 cursor-pointer"><p-checkbox [(ngModel)]="changeStates" [binary]="true" (onChange)="loadLogs(lastGridLogEvent)" [ngModelOptions]="{standalone: true}" />Cambios de estados</label>
                    <div class="flex-grow-1"></div>                    
                    <p-button *ngIf="allowWrite && loginService.hasPermission('CASES.WRITE_CASE_LOG')" label="Añadir comunicación" icon="pi pi-plus" (click)="addEvent()" />
                </div>
                <p-table *ngIf="case.id" #grid [value]="caseLogs" [lazy]="true" (onLazyLoad)="loadLogs($event)" [loading]="loadingLogs"
                    [totalRecords]="totalLogsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [paginator]="true" [rows]="100" [rowsPerPageOptions]="[100,250,500]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="log.date" width="180">Fecha <p-sortIcon field="log.date"></p-sortIcon></th>
                            <th>Mensaje </th>
                            <th>Marcar como completado</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-caseLogs let-columns="columns">
                        <tr>
                            <td>
                                <div class="flex gap-2">
                                    <div class="event-icon" *ngIf="caseLogs.resourceType==null" pTooltip="Actualización">
                                        <i class="pi pi-info-circle" *ngIf="caseLogs.resourceType==null"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Mail' && caseLogs.direction=='In'" pTooltip="Email recibido">
                                        <i class="pi pi-envelope"></i>
                                        <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Mail' && caseLogs.direction=='Out'" pTooltip="Email enviado">
                                        <i class="pi pi-envelope"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Call' && caseLogs.direction=='In'" pTooltip="Llamada recibida">
                                        <i class="pi pi-phone"></i>
                                        <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Call' && caseLogs.direction=='Out'" pTooltip="Llamada realizada">
                                        <i class="pi pi-phone"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='SMS' && caseLogs.direction=='Out'" pTooltip="Mensaje enviado">
                                        <i class="pi pi-comment"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Whatsapp' && caseLogs.direction=='Out'" pTooltip="Whatsapp enviado">
                                        <i class="pi pi-comment"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Whatsapp' && caseLogs.direction=='In'" pTooltip="Whatsapp recibido">
                                        <i class="pi pi-comment"></i>
                                        <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Chat' && caseLogs.direction=='In'" pTooltip="Chat recibido">
                                        <i class="pi pi-comments"></i>
                                        <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Chat' && caseLogs.direction=='Out'" pTooltip="Chat enviado">
                                        <i class="pi pi-comments"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Manual' && caseLogs.direction=='Out'" pTooltip="Evento manual">
                                        <i class="pi  pi-user-edit"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Incident' && caseLogs.direction=='Out'" pTooltip="Incidencia">
                                        <i class="pi pi-exclamation-triangle"></i>
                                        <i class="pi pi-arrow-up-right top-icon top-icon-green"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Incident' && caseLogs.direction=='In'" pTooltip="Incidencia">
                                        <i class="pi pi-exclamation-triangle"></i>
                                        <i class="pi pi-arrow-down-left top-icon top-icon-red"></i>
                                    </div>
                                    <div class="event-icon" *ngIf="caseLogs.resourceType=='Transaction'" pTooltip="Factura o albarán">
                                        <i class="pi pi-euro"></i>
                                    </div>
                                    <div>
                                        {{caseLogs.date | date: 'dd/MM/yyyy HH:mm'}}<br>
                                        <small>
                                            <b>
                                                <i class="pi pi-user" style="font-size: 8px"></i>
                                                {{caseLogs.createdByUser.name}}
                                            </b>
                                            
                                        </small>
                                    </div>
                                </div>
                            </td>
                            <td (dblclick)="showResourceInfoFromLog(caseLogs)">
                                <div class="flex gap-2">
                                    <div *ngIf="caseLogs.caseLogTypeId">
                                        <i *ngIf="caseLogs.caseLogType.iconClass" class="pi" [ngClass]="caseLogs.caseLogType.iconClass" pTooltip="{{caseLogs.caseLogType.name}}"></i>
                                    </div>
                                    <a *ngIf="caseLogs.resourceId != null && (caseLogs.resourceType == 'Mail' || (caseLogs.resourceType == 'Call' && allowRecordingAccess) || caseLogs.resourceType == 'Incident')" size="small" severity="secondary" pTooltip="Ver mas"  (click)="showResourceInfoFromLog(caseLogs)">
                                        <i *ngIf="!resourceCaseLog[caseLogs.resourceId]" class="pi pi-chevron-right"></i>
                                        <i *ngIf="resourceCaseLog[caseLogs.resourceId]" class="pi pi-chevron-down"></i>
                                    </a>
                                    <a *ngIf="caseLogs.caseLogTypeId&&caseLogs.caseLogType.code=='PROCESSOR-ASSIGN'" size="small" severity="secondary" pTooltip="Ver mas"  (click)="showInfoAssignProcessor(caseLogs)">
                                        <i *ngIf="!caseLogs.show" class="pi pi-chevron-right"></i>
                                        <i *ngIf="caseLogs.show" class="pi pi-chevron-down"></i>
                                    </a>
                                    <a *ngIf="caseLogs.resourceType=='AgentSession'" size="small" severity="secondary" pTooltip="Ver capítulos"  (click)="caseLogs.show = !caseLogs.show">
                                        <i *ngIf="!caseLogs.show" class="pi pi-chevron-right"></i>
                                        <i *ngIf="caseLogs.show" class="pi pi-chevron-down"></i>
                                    </a>
                                    <div *ngIf="caseLogs.integrationEvent">
                                        <i *ngIf="caseLogs.integrationEvent.status=='pending'" class="pi pi-cog" style="color: var(--color-warning)" pTooltip="Envío a compañia pendiente"></i>
                                        <i *ngIf="caseLogs.integrationEvent.status=='queued'" class="pi pi-cog" style="color: var(--color-warning)" pTooltip="Envío vía SIE, esperando confirmación de estado por parte de SIE"></i>
                                        <i *ngIf="caseLogs.integrationEvent.status=='success'" class="pi pi-check-circle" style="color: var(--color-success)" pTooltip="Envíado a compañia correctamente"></i>
                                        <i *ngIf="caseLogs.integrationEvent.status=='error'" class="pi pi-times" style="color: var(--color-danger)" pTooltip="Error enviando compañia. Error SIE: {{caseLogs.integrationEvent.statusMessage}}"></i>
                                    </div>
                                    <div class="flex flex-column">
                                        <div *ngIf="(caseLogs.caseLogTypeId==null||caseLogs.caseLogType.code!='PROCESSOR-ASSIGN') && caseLogs.resourceType!='AgentSession'" [innerHtml]="caseLogs.message" style="white-space: pre-wrap;"></div>
                                        <div *ngIf="caseLogs.caseLogTypeId&&caseLogs.caseLogType.code=='PROCESSOR-ASSIGN'" style="white-space:pre-wrap;">Información asignación de tramitador</div>
                                        <div *ngIf="caseLogs.resourceType=='AgentSession'" style="white-space:pre-wrap;"><b>Sesión de agente completada.</b></div>
                                        <!-- si el enveto tiene transcribed, mostramos el boton de ver transcripcion -->
                                        <div *ngIf="caseLogs.caseLogMetadata?.transcribed">
                                            <p-button label="Ver transcripción" icon="pi pi-eye"
                                                    (click)="showRecordingTranscription(caseLogs.resourceId)"></p-button>
                                        </div>
                                        
                                        <!-- archivos del caselog -->
                                        <div *ngIf="caseLogs.caseLogFiles && caseLogs.caseLogFiles.length > 0" class="mt-2">
                                            <div class="mt-1 flex flex-wrap gap-2">
                                                <button class="p-button p-button-text" size="small" *ngFor="let file of caseLogs.caseLogFiles; index as i" (click)="downloadFile(file.fileId)">
                                                    <i class="pi pi-file"></i>&nbsp;Documento {{(i+1)}}
                                                </button>
                                            </div>
                                        </div>

                                        <!--archivos de evento de integracion-->
                                        <div *ngIf="caseLogs.integrationEvent && getIntegrationEventFiles(caseLogs.integrationEvent)?.length > 0" class="mt-2">
                                            <div class="mt-1 flex flex-wrap gap-2">
                                                <button class="p-button p-button-text" size="small" *ngFor="let file of getIntegrationEventFiles(caseLogs.integrationEvent)" (click)="downloadFile(file.id)">
                                                    <i class="pi pi-file"></i>&nbsp;{{file.name}}
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="resourceCaseLog[caseLogs.resourceId]" class="mt-2">
                                    <p-card *ngIf="caseLogs.resourceType == 'Incident'" styleClass="p-card-content-no-padding p-card-body-no-padding">
                                        <div><b>Fecha:</b> {{resourceCaseLog[caseLogs.resourceId].date}}</div>
                                        <div><b>Descripción:</b> {{resourceCaseLog[caseLogs.resourceId].message}}</div>                                        
                                    </p-card>
                                    <p-card *ngIf="caseLogs.resourceType == 'Mail'" styleClass="p-card-content-no-padding p-card-body-no-padding">
                                        <div>
                                            <b>Desde:&nbsp;</b> 
                                             <a *ngIf="resourceCaseLog[caseLogs.resourceId].message?.from" (click)="mail(resourceCaseLog[caseLogs.resourceId].message?.from, null, null, false)" class="p-button-link"><i
                                        class="pi pi-envelope"></i>{{resourceCaseLog[caseLogs.resourceId].message?.from}}</a>
                                        </div>
                                        <div><b>Para:</b> {{resourceCaseLog[caseLogs.resourceId].receipts}}</div>
                                        <div><b>Asunto:</b> {{resourceCaseLog[caseLogs.resourceId].message?.subject}}</div>
                                        <div *ngIf="resourceCaseLog[caseLogs.resourceId].message.attachments.length>0" class="mt-2 mail-attachments-box">
                                            <div *ngFor="let attachment of resourceCaseLog[caseLogs.resourceId].message.attachments" class="mr-2">
                                                <a (click)="downloadFile(attachment.fileId)">
                                                    <i class="pi pi-file"></i> {{attachment.file?.fileName}}
                                                </a>
                                            </div>
                                        </div>
                                        <div class="mt-2  mail-body-box" [innerHtml]="getMailBody(resourceCaseLog[caseLogs.resourceId].message)"></div>
                                    </p-card>
                                    <p-card *ngIf="caseLogs.resourceType == 'Call'" styleClass="p-card-content-no-padding">
                                        <div *ngIf="resourceCaseLog[caseLogs.resourceId] && resourceCaseLog[caseLogs.resourceId].recording">
                                            <div class="flex align-items-center">
                                                <audio controls class="flex-grow-1">
                                                    <source src="{{getRecordingUrl(resourceCaseLog[caseLogs.resourceId].recording)}}" type="audio/mpeg">
                                                    Tu navegador no soporta reproducción de audio
                                                </audio>
                                                <p-button label="Generar transcripción" icon="pi pi-microchip-ai"
                                                    *ngIf="!resourceCaseLog[caseLogs.resourceId].recording?.transcription && loginService.hasPermission('CASES.AI_TRANSCRIBE')"
                                                    [disabled]="!resourceCaseLog[caseLogs.resourceId].call?.talkSec"
                                                    (click)="transcribeRecording(resourceCaseLog[caseLogs.resourceId].recording)"></p-button>
                                                    
                                                <p-button label="Ver transcripción" icon="pi pi-eye"
                                                    *ngIf="resourceCaseLog[caseLogs.resourceId].recording?.transcription"
                                                    (click)="showRecordingTranscription(caseLogs.resourceId)"></p-button>
                                            </div>
                                        </div>
                                    </p-card>
                                </div>
                                <div *ngIf="caseLogs.caseLogTypeId&&caseLogs.caseLogType.code=='PROCESSOR-ASSIGN'&&caseLogs.show" [innerHtml]="caseLogs.message" style="white-space: pre-wrap; margin: 15px;"></div>
                                <div *ngIf="caseLogs.resourceType=='AgentSession'&&caseLogs.show" [innerHtml]="caseLogs.message" style="white-space: pre-wrap; margin: 15px;"></div>
                            </td>
                            <td>     
                                <div *ngIf="caseLogs.completedAt != null">
                                    {{caseLogs.completedAt | date: 'dd/MM/yyyy HH:mm'}}<br>
                                    <small>
                                        <b>
                                            <i class="pi pi-user" style="font-size: 8px"></i>
                                            {{caseLogs.completedByUser?.name}}
                                        </b>                                        
                                    </small>
                                </div>                                                
                                <p-checkbox *ngIf="caseLogs.direction == 'In' && caseLogs.caseLogTypeId != null && caseLogs.completedAt == null"  
                                    [binary]="true"
                                    [(ngModel)]="caseLogs.completed" 
                                    (onChange)="caseLogCompleted($event, caseLogs)">
                                </p-checkbox >                            
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="3">
                                No se han encontrado eventos
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-trabajos">                
                <ng-template pTemplate="header">      
                    <div class="flex justify-between items-center w-full align-items-center">
                        Trabajos realizados 
                        <div class="flex gap-2 ml-auto">
                            <p-button *ngIf="allowWrite" [disabled]="case.caseState?.code=='ECONOMIC_REVIEW'" label="Facturar" icon="pi pi-money-bill" (click)="invoice(); $event.stopPropagation()" size="small"/>
                             <p-tag *ngIf="countCompensationTransactions>0" severity="secondary" value="Dev Client: {{getWorkersSummary().totalDevClient | currency: 'EUR'}}" 
                                [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                            <p-tag severity="secondary" value="Total coste: {{getWorkersSummary().totalWorkerJobs | currency: 'EUR'}}" 
                                [ngClass]="{'flex items-center justify-center text-center': true}"/>      
                            <p-tag severity="secondary" value="Total compañía: {{getWorkersSummary().totalCompanyJobs | currency: 'EUR'}}" 
                                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                            <!--<p-tag severity="secondary" value="Total compras: {{getWorkersSummary().totalPurchases | currency: 'EUR'}}" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>-->
                             <p-tag severity="secondary" value="Total materiales: {{getWorkersSummary().subtotalMaterials | currency: 'EUR'}}" 
                                [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                            <p-tag [severity]="getWorkersSummary().totalProfitPercent > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getWorkersSummary().totalProfitPercent > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'" value="{{getWorkersSummary().totalProfitPercent | number:'1.2-2'}}% beneficio" 
                                [ngClass]="{'flex items-center justify-center text-center': true}"/>    
                            <p-tag [severity]="getWorkersSummary().totalProfitPercent > (case.contract?.profitDesiredPercent ?? 0) ? 'success' : getWorkersSummary().totalProfitPercent > (case.contract?.profitMinPercent ?? 0) ? 'warn' : 'danger'" value="{{getWorkersSummary().totalProfit | currency: 'EUR'}} beneficio" 
                                [ngClass]="{'flex items-center justify-center text-center': true}"/>  
                        </div>                      
                    </div>
                </ng-template>
                <div *ngIf="hasPolicyFranchise()">
                    <p-messages severity="error">
                        <ng-template pTemplate>
                            Atención, este expediente tiene una franquicia de {{case.clientPolicy?.franchisePrice | currency:'EUR':true}}.
                        </ng-template>
                    </p-messages>
                </div>
                <div *ngIf="case.contract?.urgentPlusReminder && case.isUrgent">
                    <p-messages severity="warn" [closable]="false" >
                        <ng-template pTemplate>
                            Revisa si es posible aplicar el plus de urgencia en los trabajos de este expediente
                        </ng-template>
                    </p-messages>
                </div>
                
                <app-cases-jobs #casesJobsComponent (onServiceChange)="loadServices()" (onJobsChange)="loadJobs()" *ngIf="casesJobsVisible && case?.id" [caseId]="case.id"></app-cases-jobs>
                
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-presupuestos">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Presupuestos</span>
                        <div class="flex-grow-1"></div>
                        <span *ngIf="caseTransactionsBudgetResume!=0" class="p-tag flex gap-2 align-items-center" 
                            [class.p-tag-danger]="caseTransactionsBudgetResume<0" [class.p-tag-success]="caseTransactionsBudgetResume>0"
                        >
                            <span class="p-tag-label">{{caseTransactionsBudgetResume | number:'1.0-2'}} €</span>
                        </span>
                        <span *ngIf="caseTransactionsBudgetResumePercent!=0" class="p-tag flex gap-2 align-items-center" 
                            [class.p-tag-danger]="caseTransactionsBudgetResumePercent<0" [class.p-tag-success]="caseTransactionsBudgetResumePercent>0"
                        >
                            <span class="p-tag-label">{{caseTransactionsBudgetResumePercent | number:'1.0-2'}} %</span>
                        </span>
                    </span>
                </ng-template>
                <div class="flex justify-content-end mb-2">
                    <div class="flex-grow-1"></div>
                    <p-button *ngIf="allowWrite" label="Presupuesto compañía" icon="pi pi-plus" styleClass="ml-2"
                        (click)="editTransaction('company_outgoing_budget', null)" />
                    <p-button *ngIf="allowWrite" label="Presupuesto asegurado" icon="pi pi-plus" styleClass="ml-2"
                        (click)="editTransaction('outgoing_budget', null)" />
                    <p-button *ngIf="allowWrite" label="Presupuesto implicado" icon="pi pi-plus" styleClass="ml-2"
                        (click)="editTransaction('affected_outgoing_budget', null)" />
                    <p-button *ngIf="allowWrite" label="Presupuesto operario" icon="pi pi-plus" styleClass="ml-2"
                        (click)="editTransaction('ingoing_budget_worker', null)" />
                </div>
                <p-table styleClass="mt-4"
                 #grid [value]="caseTransactionsBudget" [loading]="loadingTransactionsBudget" [paginator]="true" [rows]="25"
                    [totalRecords]="totalTransactionsBudgetRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[25,50,100]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="code">Tipo </th>
                            <th pSortableColumn="createdByUser.name">Creado por <p-sortIcon field="createdByUser.name"></p-sortIcon></th>
                            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
                            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                            <th pSortableColumn="transactionState.name">Estado <p-sortIcon
                                    field="transactionState.name"></p-sortIcon></th>
                            <th pSortableColumn="thirdPartyId">Tercero <p-sortIcon field="thirdPartyId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="subtotal">Precio <p-sortIcon field="subtotal"></p-sortIcon></th>
                            <th pSortableColumn="taxAmount">Impuestos <p-sortIcon field="taxAmount"></p-sortIcon></th>
                            <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
                            <th pSortableColumn="forProfitability">Rentabilidad <p-sortIcon field="forProfitability"></p-sortIcon></th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-transaction let-columns="columns">
                        <tr (dblclick)="editTransaction(transaction.transactionType.code, transaction)">
                            
                            <td>{{transaction.transactionType.name}}</td>
                            <td>{{transaction.createdByUser?.name}}</td>
                            <td>{{transaction.code}}</td>
                            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
                            <td>
                                <span class="p-tag" 
                                        [style.backgroundColor]="transaction.transactionState?.backgroundColor"
                                        [style.color]="transaction.transactionState?.foregroundColor">
                                    <span class="p-tag-label">{{transaction.transactionState?.name}}</span>
                                </span>
                            </td>
                            <td><app-deleted-label [resource]="transaction.thirdParty"></app-deleted-label> <small *ngIf="transaction.caseServiceId"><br>Cita: {{transaction.caseService?.date | date: 'dd/MM/yyyy HH:mm'}} <label *ngIf="transaction.transactionType.code!='ingoing_budget_worker'">({{transaction.caseService?.worker?.name}})</label></small></td>
                            <td>{{transaction.subtotal | currency:'EUR'}}</td>
                            <td>{{transaction.taxAmount | currency:'EUR'}}</td>
                            <td>{{transaction.total | currency:'EUR'}}</td>
                            <td>                                                
                                <p-checkbox  
                                    [binary]="true"
                                    [(ngModel)]="transaction.forProfitability" 
                                    (onChange)="reloadTransactionsBudget($event, transaction)">
                                </p-checkbox >                            
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                
                                    <!--<p-button *ngIf="transaction.transactionType.code=='ingoing_budget_worker'&&transaction.transactionState.code!='refused'" (click)="convertToTransacion('company_outgoing_budget', transaction)" [rounded]="true"
                                        [text]="false" pTooltip="Convertir a presupuesto de compañia"><i class="pi pi-directions"></i></p-button>-->
                                    <p-button *ngIf="transaction.transactionType.document_type" (click)="exportTransaction(transaction.transactionType.code, transaction.id)" [rounded]="true"
                                        [text]="false" severity="secondary">
                                        <i class="pi pi-print"></i></p-button>
                                    <p-button *ngIf="transaction.deleteButton" (click)="deleteTransactionBudget(transaction)"
                                        [rounded]="true" [text]="false" severity="danger"><i
                                            class="pi pi-trash"></i></p-button>
                                    <p-button *ngIf="allowWrite" (click)="editTransaction(transaction.transactionType.code, transaction)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="7">
                                No se ha encontrado transacciones
                            </td>
                        </tr>
                    </ng-template>
                </p-table>

                <h2>Solicitudes de compra</h2>
                <p-table styleClass="mt-4" #grid [value]="caseTransactionsPurchase" [lazy]="true"
                    [loading]="loadingTransactionsPurchase" [paginator]="true" [rows]="25"
                    [totalRecords]="totalTransactionsPurchaseRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
                            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                            <th pSortableColumn="relatedInvoiceCode">Nº factura prov. <p-sortIcon field="relatedInvoiceCode"></p-sortIcon></th>
                            <th pSortableColumn="transactionState.name">Estado <p-sortIcon
                                    field="transactionState.name"></p-sortIcon></th>
                            <th pSortableColumn="thirdPartyId">Tercero <p-sortIcon field="thirdPartyId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="subtotal">Precio <p-sortIcon field="subtotal"></p-sortIcon></th>
                            <th pSortableColumn="discount">Descuento <p-sortIcon field="discount"></p-sortIcon></th>
                            <th pSortableColumn="subtotal">Subtotal <p-sortIcon field="subtotal"></p-sortIcon></th>
                            <th pSortableColumn="taxAmount">Iva <p-sortIcon field="taxAmount"></p-sortIcon></th>
                            <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>                            <th pSortableColumn="forProfitability">Rentabilidad <p-sortIcon field="forProfitability"></p-sortIcon></th>
                            <th width="100"></th>    
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-transaction let-columns="columns">
                        <tr (dblclick)="editTransaction('purchase_order', transaction)">
                            <td>{{transaction.code}}</td>
                            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
                            <td>{{transaction.relatedInvoiceCode}}</td>
                            <td>
                                <span class="p-tag" 
                                        [style.backgroundColor]="transaction.transactionState?.backgroundColor"
                                        [style.color]="transaction.transactionState?.foregroundColor">
                                    <span class="p-tag-label">{{transaction.transactionState?.name}}</span>
                                </span>
                            </td>
                            <td><app-deleted-label [resource]="transaction.thirdParty"></app-deleted-label></td> 
                            <td>
                                {{(transaction.subtotal+transaction.discountAmount) | currency:'EUR'}}
                            </td>                                                        
                            <td>
                                {{transaction.discountAmount | currency:'EUR'}}
                            </td>                                                        
                            <td>
                                {{transaction.subtotal | currency:'EUR'}}
                            </td>                                                      
                            <td>
                                {{transaction.taxAmount | currency:'EUR'}}
                            </td>
                            <td>
                                {{transaction.total | currency:'EUR'}}
                            </td>
                            <td>                                                
                                <p-checkbox  
                                    [binary]="true"
                                    [(ngModel)]="transaction.forProfitability" 
                                    (onChange)="reloadTransactionsBudget($event, transaction)">
                                </p-checkbox >                            
                            </td>                                                       
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngIf="allowWrite" (click)="exportTransaction('purchase_order', transaction.id)" [rounded]="true"><i class="pi pi-print"></i></p-button>
                                    <p-button *ngIf="allowWrite" (click)="editTransaction('purchase_order', transaction)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="6">
                                No se han encontrado solicitudes de compra
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-adjuntos">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Adjuntos</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countCaseFiles>0"  value="{{countCaseFiles}} adjuntos" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>
                <div class="flex mb-2 gap-2">
                    <p-dropdown [(ngModel)]="caseFileCategoryFilter" [options]="caseFileCategories" optionLabel="name"
                        optionValue="id" appendTo="body" placeholder="Selecciona una categoría a filtrar"
                        (onChange)="onFileCategoryFilterChange()" showClear></p-dropdown>

                    <div class="flex-grow-1"></div>
                    
                    <p-button *ngIf="allowWrite" label="Descargar todas" icon="pi pi-download"
                        (click)="generateZIP()" />
                    <p-button *ngIf="allowWrite" label="Informe fotográfico" icon="pi pi-image"
                        (click)="displayModalPhoto()" />

                    <p-button *ngIf="allowWrite" label="Añadir archivo" icon="pi pi-plus"
                        (click)="editCaseFile(null)" />
                </div>
                <!--<p-overlayPanel #op [appendTo]="'body'" styleClass="image-overlay-panel">
                    <img *ngIf="opFile" [src]="imagesUrl + opFile.fileId + '/show'" style="max-height: 600px; max-width: 500px; border-radius: 10px;" />
                </p-overlayPanel>-->
                <div class="mb-4" *ngIf="caseFilesInsured.length > 0">
                    <p-card header="Asegurado">
                        <div class="grid">
                            <div *ngFor="let file of caseFilesInsured" class="case-file">
                                <div *ngIf="fileIsAnImage(file.file)"
                                    style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                    <div class="case-image">
                                        <span class="visibility-badge visibility-badge-left"
                                            [pTooltip]="file.showMobile ? 'Visible en la app' : 'No visible en la app'" tooltipPosition="top">
                                            <i class="pi pi-mobile" [class.visibility-off]="!file.showMobile"></i>
                                        </span>
                                        <span class="visibility-badge visibility-badge-right"
                                            [pTooltip]="file.showCaseTracking ? 'Visible en Sigue tu expediente' : 'No visible en Sigue tu expediente'" tooltipPosition="top">
                                            <i class="pi pi-eye" [class.visibility-off]="!file.showCaseTracking"></i>
                                        </span>
                                        <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file?.fileName}}" (click)="downloadFile(file.fileId)"
                                            (mouseenter)="hoveredImage = file"
                                            (mouseleave)="hoveredImage = null"
                                        />
                                    </div>
                                    <div class="flex justify-content-between align-items-center mt-1">
                                        <span class="file-name"> {{file.file?.fileName}}</span>
                                        <div>
                                            <p-menu #menu [model]="file.actions" [popup]="true" appendTo="body" />
                                            <p-button icon="pi pi-ellipsis-v" (click)="menu.toggle($event);$event.stopPropagation()"></p-button>
                                        </div>
                                    </div>
                                    <div *ngIf="file.notes" class="file-notes" [pTooltip]="file.notes" tooltipPosition="top">{{ file.notes }}</div>
                                </div>
                                <div *ngIf="!fileIsAnImage(file.file)"
                                    style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                    <div class="case-image">
                                        <span class="visibility-badge visibility-badge-left"
                                            [pTooltip]="file.showMobile ? 'Visible en la app' : 'No visible en la app'" tooltipPosition="top">
                                            <i class="pi pi-mobile" [class.visibility-off]="!file.showMobile"></i>
                                        </span>
                                        <span class="visibility-badge visibility-badge-right"
                                            [pTooltip]="file.showCaseTracking ? 'Visible en Sigue tu expediente' : 'No visible en Sigue tu expediente'" tooltipPosition="top">
                                            <i class="pi pi-eye" [class.visibility-off]="!file.showCaseTracking"></i>
                                        </span>
                                        <i class="pi pi-file" style="font-size: 80px;"></i>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mt-1">
                                        <span>{{file.file.fileName}}</span>
                                        <div>
                                            <p-menu #menu [model]="file.actions" [popup]="true" appendTo="body" />
                                            <p-button icon="pi pi-ellipsis-v" (click)="menu.toggle($event);$event.stopPropagation()"></p-button>
                                        </div>
                                    </div>
                                    <div *ngIf="file.notes" class="file-notes" [pTooltip]="file.notes" tooltipPosition="top">{{ file.notes }}</div>
                                </div>
                            </div>
                        </div>
                    </p-card>
                </div>
                <div class="mb-4" *ngIf="caseFilesWithoutService.length > 0">
                    <p-card header="Generales">
                        <ng-container *ngFor="let group of caseFilesGeneralGroups">
                            <!-- cabecera de la fila de sesión (los adjuntos sin sesión no llevan cabecera) -->
                            <div *ngIf="group.label" class="session-group-title">
                                {{ group.label }}
                            </div>
                            <div class="grid">
                                <div *ngFor="let file of group.files" class="case-file">
                                    <div *ngIf="fileIsAnImage(file.file)"
                                        style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                        <div class="case-image">
                                        <span class="visibility-badge visibility-badge-left"
                                            [pTooltip]="file.showMobile ? 'Visible en la app' : 'No visible en la app'" tooltipPosition="top">
                                            <i class="pi pi-mobile" [class.visibility-off]="!file.showMobile"></i>
                                        </span>
                                        <span class="visibility-badge visibility-badge-right"
                                            [pTooltip]="file.showCaseTracking ? 'Visible en Sigue tu expediente' : 'No visible en Sigue tu expediente'" tooltipPosition="top">
                                            <i class="pi pi-eye" [class.visibility-off]="!file.showCaseTracking"></i>
                                        </span>
                                            <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file?.fileName}}" (click)="downloadFile(file.fileId)"
                                                (mouseenter)="hoveredImage = file"
                                                (mouseleave)="hoveredImage = null"
                                            />
                                        </div>
                                        <div class="flex justify-content-between align-items-center mt-1">
                                            <span class="file-name"> {{file.file?.fileName}}</span>
                                            <div>
                                                <p-menu #menu [model]="file.actions" [popup]="true" appendTo="body" />
                                                <p-button icon="pi pi-ellipsis-v" (click)="menu.toggle($event);$event.stopPropagation()"></p-button>
                                            </div>
                                        </div>
                                        <div *ngIf="file.notes" class="file-notes" [pTooltip]="file.notes" tooltipPosition="top">{{ file.notes }}</div>
                                    </div>
                                    <div *ngIf="!fileIsAnImage(file.file)"
                                        style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                        <div class="case-image">
                                        <span class="visibility-badge visibility-badge-left"
                                            [pTooltip]="file.showMobile ? 'Visible en la app' : 'No visible en la app'" tooltipPosition="top">
                                            <i class="pi pi-mobile" [class.visibility-off]="!file.showMobile"></i>
                                        </span>
                                        <span class="visibility-badge visibility-badge-right"
                                            [pTooltip]="file.showCaseTracking ? 'Visible en Sigue tu expediente' : 'No visible en Sigue tu expediente'" tooltipPosition="top">
                                            <i class="pi pi-eye" [class.visibility-off]="!file.showCaseTracking"></i>
                                        </span>
                                        <i class="pi pi-file" style="font-size: 80px;"></i>
                                    </div>
                                        <div class="flex justify-content-between align-items-center mt-1">
                                            <span>{{file.file.fileName}}</span>
                                            <div>
                                                <p-menu #menu [model]="file.actions" [popup]="true" appendTo="body" />
                                                <p-button icon="pi pi-ellipsis-v" (click)="menu.toggle($event);$event.stopPropagation()"></p-button>
                                            </div>
                                        </div>
                                        <div *ngIf="file.notes" class="file-notes" [pTooltip]="file.notes" tooltipPosition="top">{{ file.notes }}</div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </p-card>
                </div>
                <div class="hovered-image" *ngIf="hoveredImage!=null">
                    <img [src]="imagesUrl + hoveredImage.fileId + '/show'" style="max-width: 600px; max-height: 600px;" />
                </div>
                <div *ngFor="let service of caseFilesServices" class="mb-2">
                    <p-card  >
                        <ng-template pTemplate="header">
                            <span class="flex items-center gap-2 w-full align-items-center">
                                <span class="font-bold whitespace-nowrap">{{service.name}}</span>
                                <div class="flex-grow-1"></div>
                                <p-button *ngIf="allowWrite" label="Descargar fotos visita" icon="pi pi-download" (click)="generateZIP(service.id)" />
                            </span>
                        </ng-template>
                        

                        <div class="grid case-file-container">
                            <div *ngFor="let file of filesByService(service.id)" class="case-file">
                                <div *ngIf="fileIsAnImage(file.file)"
                                    style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                    <div class="case-image">
                                        <span class="visibility-badge visibility-badge-left"
                                            [pTooltip]="file.showMobile ? 'Visible en la app' : 'No visible en la app'" tooltipPosition="top">
                                            <i class="pi pi-mobile" [class.visibility-off]="!file.showMobile"></i>
                                        </span>
                                        <span class="visibility-badge visibility-badge-right"
                                            [pTooltip]="file.showCaseTracking ? 'Visible en Sigue tu expediente' : 'No visible en Sigue tu expediente'" tooltipPosition="top">
                                            <i class="pi pi-eye" [class.visibility-off]="!file.showCaseTracking"></i>
                                        </span>
                                        <img [d-img-lazy]="imagesUrl + file.fileId + '/thumbnail'" alt="{{file.file.fileName}}" (click)="downloadFile(file.fileId)"
                                            (mouseenter)="hoveredImage = file"
                                            (mouseleave)="hoveredImage = null"/>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mt-1">
                                        <span class="file-name"> {{file.caseFileCategory?.name}} - {{file.file.fileName}}</span>
                                        <div >
                                            <p-menu #menu [model]="file.actions" [popup]="true" appendTo="body" />
                                            <p-button icon="pi pi-ellipsis-v" (click)="menu.toggle($event);$event.stopPropagation()"></p-button>
                                        </div>
                                    </div>
                                    <div *ngIf="file.notes" class="file-notes" [pTooltip]="file.notes" tooltipPosition="top">{{ file.notes }}</div>
                                </div>
                                <div *ngIf="!fileIsAnImage(file.file)"
                                    style="border: 1px solid #e9e9e9; padding: 10px; border-radius: 10px;">
                                    <div class="case-image">
                                        <span class="visibility-badge visibility-badge-left"
                                            [pTooltip]="file.showMobile ? 'Visible en la app' : 'No visible en la app'" tooltipPosition="top">
                                            <i class="pi pi-mobile" [class.visibility-off]="!file.showMobile"></i>
                                        </span>
                                        <span class="visibility-badge visibility-badge-right"
                                            [pTooltip]="file.showCaseTracking ? 'Visible en Sigue tu expediente' : 'No visible en Sigue tu expediente'" tooltipPosition="top">
                                            <i class="pi pi-eye" [class.visibility-off]="!file.showCaseTracking"></i>
                                        </span>
                                        <i class="pi pi-file" style="font-size: 80px;"></i>
                                    </div>
                                    <div class="flex justify-content-between align-items-center mt-1"  (click)="downloadFile(file.fileId)">
                                        <span>{{file.file.fileName}}</span>
                                        <div>
                                            <p-menu #menu [model]="file.actions" [popup]="true" appendTo="body"/>
                                            <p-button icon="pi pi-ellipsis-v" (click)="menu.toggle($event);$event.stopPropagation()"></p-button>
                                        </div>
                                    </div>
                                    <div *ngIf="file.notes" class="file-notes" [pTooltip]="file.notes" tooltipPosition="top">{{ file.notes }}</div>
                                </div>
                            </div>
                        </div>
                    </p-card>
                </div>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-implicados">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Implicados</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countAffecteds>0"  value="{{countAffecteds}} implicados" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>

                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir implicado" icon="pi pi-plus"
                        (click)="editAffected(null)" />
                </div>
                <p-table #grid [value]="totalAffecteds" [loading]="loadingAffecteds" [paginator]="true" [rows]="5" 
                    [totalRecords]="totalAffectedsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="partyType">Tipo <p-sortIcon field="partyType"></p-sortIcon></th>
                            <th pSortableColumn="date">Nombre <p-sortIcon field="name"></p-sortIcon></th>
                            <th pSortableColumn="address">Dirección <p-sortIcon field="address"></p-sortIcon></th>
                            <th pSortableColumn="phone1">Teléfonos <p-sortIcon field="phone1"></p-sortIcon></th>
                            <th pSortableColumn="email">Correo electronico <p-sortIcon field="email"></p-sortIcon></th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-affected let-columns="columns">
                        <tr (dblclick)="editAffected(affected)">
                            <td>{{affectedPartyTypeLabel(affected.partyType)}}</td>
                            <td>{{affected.name}}</td>
                            <td>{{affected.address?.fullAddress}}</td>
                            <td>
                                <div class="flex gap-2">
                                    <a *ngIf="affected.phone1" (click)="showPhoneOverlayPanel($event, affected.phone1, affected.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{affected.phone1}}</a>
                                    <a *ngIf="affected.phone2" (click)="showPhoneOverlayPanel($event, affected.phone2, affected.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{affected.phone2}}</a>
                                </div>
                            </td>
                            <td>
                                <a *ngIf="affected.email" (click)="mail(affected.email, case.id, null, false)"
                                    class="flex gap-1 align-items-center"><i
                                        class="pi pi-envelope"></i>{{affected.email}}</a>
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngIf="allowDelete" (click)="deleteAffected(affected.id)" [rounded]="true"
                                        [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                    <p-button *ngIf="allowWrite" (click)="editAffected(affected)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-peritos">
                 <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Peritos</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countExperts>0"  value="{{countExperts}} peritos" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>

                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir perito" icon="pi pi-plus" (click)="editCaseExpert()" />
                </div>
                <p-table #grid [value]="caseExperts" [loading]="loadingExperts" [paginator]="true" [rows]="5"
                    [totalRecords]="totalExpertsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="expert.name">Nombre <p-sortIcon field="expert.name"></p-sortIcon></th>
                            <th pSortableColumn="expert.address">Dirección <p-sortIcon
                                    field="expert.address"></p-sortIcon></th>
                            <th pSortableColumn="expert.phone1">Teléfonos <p-sortIcon
                                    field="expert.phone1"></p-sortIcon></th>
                            <th pSortableColumn="expert.email">Correo electrónico <p-sortIcon
                                    field="expert.email"></p-sortIcon></th>
                            <th widht="100" pSortableColumn="expert.isActive">Activo <p-sortIcon
                                    field="expert.isActive"></p-sortIcon></th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-caseExpert let-columns="columns">
                        <tr>
                            <td>{{caseExpert.expert.name}}</td>
                            <td>{{caseExpert.expert.address?.fullAddress}}</td>
                            <td>
                                <div class="flex gap-2">
                                    <a *ngIf="caseExpert.expert.phone1" (click)="showPhoneOverlayPanel($event, caseExpert.expert.phone1, caseExpert.expert?.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{caseExpert.expert.phone1}}</a>
                                    <a *ngIf="caseExpert.expert.phone2" (click)="showPhoneOverlayPanel($event, caseExpert.expert.phone2, caseExpert.expert?.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{caseExpert.expert.phone2}}</a>
                                </div>
                            </td>
                            <td>
                                <a *ngIf="caseExpert.expert.email" (click)="mail(caseExpert.expert.email, case.id, null, false)"
                                    class="flex gap-1 align-items-center"><i
                                        class="pi pi-envelope"></i>{{caseExpert.expert.email}}</a>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="caseExpert.isActive" name="isActive" [binary]="true" [ngModelOptions]="{standalone: true}" (onChange)="saveCaseExpert(caseExpert)" />
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngIf="allowDelete" (click)="deleteCaseExpert(caseExpert.id)"
                                        [rounded]="true" [text]="false" severity="danger"><i
                                            class="pi pi-trash"></i></p-button>
                                    <p-button *ngIf="allowWrite" (click)="editExpert(caseExpert.expertId)"
                                        [rounded]="true" [text]="false"><i
                                            class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-tecnicos">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Técnicos</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countTechnicals>0"  value="{{countTechnicals}} técnicos" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>
                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir técnico" icon="pi pi-plus"
                        (click)="editCaseTechnical()" />
                </div>
                <p-table #grid [value]="caseTechnicals" [loading]="loadingTechnicals" [paginator]="true" [rows]="5"  [lazy]="true" (onLazyLoad)="loadCaseTechnicals($event)"
                    [totalRecords]="totalTechnicalsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="user.name">Nombre <p-sortIcon field="user.name"></p-sortIcon></th>
                            <th pSortableColumn="user.address.fullAddress">Dirección <p-sortIcon
                                    field="user.address.fullAddress"></p-sortIcon></th>
                            <th pSortableColumn="user.phone1">Teléfonos <p-sortIcon
                                    field="user.phone1"></p-sortIcon></th>
                            <th pSortableColumn="user.email">Correo electrónico <p-sortIcon
                                    field="user.email"></p-sortIcon></th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-caseTechnical let-columns="columns">
                        <tr>
                            <td>{{caseTechnical.user.name}}</td>
                            <td>{{caseTechnical.user.address?.fullAddress}}</td>
                            <td>
                                <div class="flex gap-2">
                                    <a *ngIf="caseTechnical.user.sipExtension" (click)="showPhoneOverlayPanel($event, caseTechnical.user.sipExtension, caseTechnical.user?.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{caseTechnical.user.sipExtension}}</a>
                                </div>
                            </td>
                            <td>
                                <a *ngIf="caseTechnical.user.email" (click)="mail(caseTechnical.user.email, case.id, null, false)"
                                    class="flex gap-1 align-items-center"><i
                                        class="pi pi-envelope"></i>{{caseTechnical.user.email}}</a>
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngIf="allowDelete" (click)="deleteCaseTechnical(caseTechnical.id)"
                                        [rounded]="true" [text]="false" severity="danger"><i
                                            class="pi pi-trash"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            
            <p-accordionTab id="accordion-tab-mediators">
                 <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Mediadores</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countMediators>0"  value="{{countMediators}} mediadores" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>
                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir mediador" icon="pi pi-plus" (click)="editCaseMediator()" />
                </div>
                <p-table #grid [value]="caseMediators" [loading]="loadingMediators" [paginator]="true" [rows]="5"
                    [totalRecords]="totalMediatorsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="expert.name">Nombre <p-sortIcon field="expert.name"></p-sortIcon></th>
                            <th pSortableColumn="expert.address">Dirección <p-sortIcon
                                    field="expert.address"></p-sortIcon></th>
                            <th pSortableColumn="expert.phone1">Teléfonos <p-sortIcon
                                    field="expert.phone1"></p-sortIcon></th>
                            <th pSortableColumn="expert.email">Correo electrónico <p-sortIcon
                                    field="expert.email"></p-sortIcon></th>
                            <th widht="100" pSortableColumn="expert.isActive">Activo <p-sortIcon
                                    field="expert.isActive"></p-sortIcon></th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-caseMediator let-columns="columns">
                        <tr>
                            <td>{{caseMediator.mediator.name}}</td>
                            <td>{{caseMediator.mediator.address?.fullAddress}}</td>
                            <td>
                                <div class="flex gap-2">
                                    <a *ngIf="caseMediator.mediator.phone1" (click)="showPhoneOverlayPanel($event, caseMediator.mediator.phone1, caseMediator.mediator?.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{caseMediator.mediator.phone1}}</a>
                                    <a *ngIf="caseMediator.mediator.phone2" (click)="showPhoneOverlayPanel($event, caseMediator.mediator.phone2, caseMediator.mediator?.name)"
                                        class="flex gap-1 align-items-center"><i
                                            class="pi pi-phone"></i>{{caseMediator.mediator.phone2}}</a>
                                </div>
                            </td>
                            <td>
                                <a *ngIf="caseMediator.mediator.email" (click)="mail(caseMediator.mediator.email, case.id, null, false)"
                                    class="flex gap-1 align-items-center"><i
                                        class="pi pi-envelope"></i>{{caseMediator.mediator.email}}</a>
                            </td>
                            <td>
                                <p-checkbox [(ngModel)]="caseMediator.isActive" name="isActive" [binary]="true" [ngModelOptions]="{standalone: true}" (onChange)="saveCaseMediator(caseMediator)" />
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngIf="allowDelete" (click)="deleteCaseMediator(caseMediator.id)"
                                        [rounded]="true" [text]="false" severity="danger"><i
                                            class="pi pi-trash"></i></p-button>
                                    <p-button *ngIf="allowWrite" (click)="editMediator(caseMediator.mediator)"
                                        [rounded]="true" [text]="false"><i
                                            class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-notas">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Notas</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countNotes>0"  value="{{countNotes}} notas" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>

                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite && loginService.hasPermission('CASES.WRITE_CASE_NOTE')" label="Añadir nota" icon="pi pi-plus" (click)="editNote(null)" />
                </div>

                <p-table #grid [value]="caseNotes" [loading]="loadingNotes" [paginator]="true" [rows]="5"
                    [lazy]="true" (onLazyLoad)="loadNotes($event)"
                    [totalRecords]="totalNotesRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="date" width="150">Fecha <p-sortIcon field="date"></p-sortIcon>
                            </th>
                            <th pSortableColumn="createdByUser" width="150">Creado por <p-sortIcon field="createdByUser"></p-sortIcon>
                            </th>
                            <th pSortableColumn="notes">Notas <p-sortIcon field="notes"></p-sortIcon>
                            </th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-note let-columns="columns">
                        <tr (dblclick)="editNote(note)">
                            <td>{{note.date | date: 'dd/MM/yyyy'}}</td>
                            <td>{{note.createdByUser?.name}}</td>
                            <td>
                                <div style="white-space: pre-wrap;">{{note.notes}}</div>
                                <ng-container *ngFor="let task of note.tasks">
                                    <div *ngIf="task.comments?.length" class="ml-2 commentsNotes" >
                                        <div *ngFor="let comment of task.comments" class="mt-2 text-500" style="font-size: 11px;">
                                            <span class="text-400">{{comment.createdByUser?.name}} · {{comment.date | date: 'dd/MM/yyyy HH:mm'}}:</span>
                                            <span [innerHTML]="comment.description"></span>
                                        </div>
                                    </div>
                                </ng-container>
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngFor="let task of note.tasks" (click)="goToTask(task)" [rounded]="true"
                                        [text]="false" pTooltip="Ver tarea relacionada"><i class="pi pi-pen-to-square"></i></p-button>
                                    <p-button *ngIf="loginService.hasPermission('CASES.DELETE_ALL_CASE_NOTE')||note.createdByUser?.id==currentUser?.id" (click)="deleteNote(note.id)" [rounded]="true"
                                        [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                    <p-button *ngIf="loginService.hasPermission('CASES.WRITE_ALL_CASE_NOTE')||note.createdByUser?.id==currentUser?.id" (click)="editNote(note)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            <!--<p-accordionTab header="Trabajos">
                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir trabajo" icon="pi pi-plus" (click)="editJob(null)" />
                </div>

                <p-card *ngFor="let worker of caseJobsWorkers" [header]="worker.name">
                    <p-table #grid [value]="jobsByWorker(worker.id)" [scrollable]="true" scrollHeight="flex">
                        <ng-template pTemplate="header" let-columns>
                            <tr>
                                <th pSortableColumn="rateLineId">Trabajo <p-sortIcon field="rateLineId"></p-sortIcon>
                                </th>
                                <th pSortableColumn="description">Descripción <p-sortIcon
                                        field="description"></p-sortIcon>
                                </th>
                                <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon>
                                </th>
                                <th pSortableColumn="quantity">Cantidad <p-sortIcon field="quantity"></p-sortIcon>
                                </th>
                                <th pSortableColumn="unitPrice">Precio <p-sortIcon field="unitPrice"></p-sortIcon>
                                </th>
                                <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon>
                                </th>
                                <th pSortableColumn="isReview">Revisado <p-sortIcon field="isReview"></p-sortIcon>
                                </th>
                                <th width=" 100"></th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-job let-columns="columns">
                            <tr (dblclick)="editJob(job)">
                                <td>{{job.rateLine?.description}}</td>
                                <td>{{job.description}}</td>
                                <td>{{job.date | date: 'dd/MM/yyyy'}}</td>
                                <td>{{job.quantity }}</td>
                                <td>{{job.unitPrice | currency:'EUR'}}</td>
                                <td>{{job.total | currency:'EUR' }}</td>
                                <td><i class="pi"
                                        [ngClass]="{ 'text-green-500 pi-check-circle': job.isReview, 'text-red-500 pi-times-circle': !job.isReview}"></i>
                                </td>
                                <td>
                                    <div class="flex gap-2 justify-content-end">
                                        <p-button *ngIf="allowDelete" (click)="deleteJob(job.id)" [rounded]="true"
                                            [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
                                        <p-button *ngIf="allowWrite" (click)="editJob(job)" [rounded]="true"
                                            [text]="false"><i class="pi pi-pencil"></i></p-button>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </p-card>

            </p-accordionTab>-->
            
            
            <p-accordionTab id="accordion-tab-solicitudes">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Solicitudes de compra</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countTransactionsPurchase>0"  value="{{countTransactionsPurchase}} solicitudes" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>
                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir solicitud" icon="pi pi-plus"
                        (click)="editTransaction('purchase_order', null)" />
                </div>
                <p-table styleClass="mt-4" #grid [value]="caseTransactionsPurchase" [lazy]="true"
                    [loading]="loadingTransactionsPurchase" [paginator]="true" [rows]="25"
                    [totalRecords]="totalTransactionsPurchaseRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
                            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                            <th pSortableColumn="relatedInvoiceCode">Nº factura prov. <p-sortIcon field="relatedInvoiceCode"></p-sortIcon></th>
                            <th pSortableColumn="transactionState.name">Estado <p-sortIcon
                                    field="transactionState.name"></p-sortIcon></th>
                            <th pSortableColumn="thirdPartyId">Tercero <p-sortIcon field="thirdPartyId"></p-sortIcon>
                            </th>
                            <th pSortableColumn="subtotal">Precio <p-sortIcon field="subtotal"></p-sortIcon></th>
                            <th pSortableColumn="discount">Descuento <p-sortIcon field="discount"></p-sortIcon></th>
                            <th pSortableColumn="subtotal">Subtotal <p-sortIcon field="subtotal"></p-sortIcon></th>
                            <th pSortableColumn="taxAmount">Iva <p-sortIcon field="taxAmount"></p-sortIcon></th>
                            <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
                            <th width="100"></th>    
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-transaction let-columns="columns">
                        <tr (dblclick)="editTransaction('purchase_order', transaction)">
                            <td>{{transaction.code}}</td>
                            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
                            <td>{{transaction.relatedInvoiceCode}}</td>
                            <td>
                                <span class="p-tag" 
                                        [style.backgroundColor]="transaction.transactionState?.backgroundColor"
                                        [style.color]="transaction.transactionState?.foregroundColor">
                                    <span class="p-tag-label">{{transaction.transactionState?.name}}</span>
                                </span>
                            </td>
                            <td><app-deleted-label [resource]="transaction.thirdParty"></app-deleted-label></td>
                            <td>
                                {{(transaction.subtotal+transaction.discountAmount) | currency:'EUR'}}
                            </td>                                                        
                            <td>
                                {{transaction.discountAmount | currency:'EUR'}}
                            </td>                                                        
                            <td>
                                {{transaction.subtotal | currency:'EUR'}}
                            </td>                                                      
                            <td>
                                {{transaction.taxAmount | currency:'EUR'}}
                            </td>
                            <td>
                                {{transaction.total | currency:'EUR'}}
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                    <p-button *ngIf="allowWrite" (click)="exportTransaction('purchase_order', transaction.id)" [rounded]="true"><i class="pi pi-print"></i></p-button>
                                    <!--<p-button *ngIf="allowDelete" (click)="deleteTransactionPurchase(transaction)"
                                        [rounded]="true" [text]="false" severity="danger"><i
                                            class="pi pi-trash"></i></p-button>-->
                                    <p-button *ngIf="allowWrite" (click)="editTransaction('purchase_order', transaction)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="6">
                                No se han encontrado solicitudes de compra
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-incidencias">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Incidencias</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countIncidents>0"  value="{{countIncidents}} incidencias" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>

                <div class="flex justify-content-end mb-2">
                    <p-button *ngIf="allowWrite" label="Añadir incidencia" icon="pi pi-plus" (click)="editCaseIncidentClient()" />
                </div>
                <p-table #grid [value]="caseIncidents" [loading]="loadingCaseIncident" [paginator]="true" [rows]="5"
                [lazy]="true" (onLazyLoad)="loadCaseIncidents($event)"
                    [totalRecords]="totalCaseIncidentsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th width="80">Procede</th>
                            <th width="120">Origen</th>
                            <th width="180">Tipo</th>
                            <th pSortableColumn="date" width="150">Fecha <p-sortIcon field="date"></p-sortIcon>
                            </th>
                            <th pSortableColumn="notes">Notas <p-sortIcon field="notes"></p-sortIcon>
                            </th>
                            <!--<th pSortableColumn="date" width="150">Tarea
                            </th>-->
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-incident let-columns="columns">
                        <tr (dblclick)="editCaseIncidentClient(incident)">
                            <td>
                                <span *ngIf="incident.isApplicable==null">Pendiente</span>
                                <span *ngIf="incident.isApplicable!=null">{{incident.isApplicable?'Si':'No'}}</span>
                            </td>
                            <td>
                                <span *ngIf="incident.source=='Worker'">Operario</span>
                                <span *ngIf="incident.source=='User'">Tramitador</span>
                                <span *ngIf="incident.source=='Company'">Compañía</span>
                            </td>
                            <td>{{incident.incidentType.name}}</td>
                            <td>{{incident.date | date: 'dd/MM/yyyy'}}</td>
                            <td>{{incident.description}}</td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                   <!-- <p-button *ngIf="allowDelete" (click)="deleteNote(note.id)" [rounded]="true"
                                        [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>-->
                                    <p-button *ngIf="allowWrite" (click)="editCaseIncidentClient(incident)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="3">
                                No se han encontrado incidencias
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>

            <p-accordionTab id="accordion-tab-consultas">
                <ng-template pTemplate="header">
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Consultas/Reclamaciones</span>
                        <div class="flex-grow-1"></div>
                         <p-tag severity="secondary" *ngIf="countNotesClient>0"  value="{{countNotesClient}} datos" 
                            [ngClass]="{'flex items-center justify-center text-center': true}"/>   
                    </span>
                 </ng-template>
                <p-table #grid [value]="caseNotesClient" [loading]="loadingNotes" [paginator]="true" [rows]="5"
                    [lazy]="true" (onLazyLoad)="loadNotesClient($event)"
                    [totalRecords]="totalNotesClientRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[5,10,20]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>
                            <th width="150">Tipo</th>
                            <th pSortableColumn="date" width="150">Fecha <p-sortIcon field="date"></p-sortIcon>
                            </th>
                            <th pSortableColumn="notes">Notas <p-sortIcon field="notes"></p-sortIcon>
                            </th>
                            <!--<th pSortableColumn="date" width="150">Tarea
                            </th>-->
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-note let-columns="columns">
                        <tr (dblclick)="editNoteClient(note)">
                            <td>
                                <span *ngIf="note.caseNoteType=='ClientQuestion'">Consulta</span>
                                <span *ngIf="note.caseNoteType=='ClientReclamation'">Reclamación</span>
                            </td>
                            <td>{{note.date | date: 'dd/MM/yyyy'}}</td>
                            <td>{{note.notes}}</td>
                            <td>
                                <div class="flex gap-2 justify-content-end">
                                   <!-- <p-button *ngIf="allowDelete" (click)="deleteNote(note.id)" [rounded]="true"
                                        [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>-->
                                    <p-button *ngIf="allowWrite" (click)="editNoteClient(note)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="6">
                                No se han encontrado ni consultas ni reclamaciones
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
            
            <p-accordionTab id="accordion-tab-devoluciones">
                <ng-template pTemplate="header">                                       
                    <span class="flex items-center gap-2 w-full align-items-center">
                        <span class="font-bold whitespace-nowrap">Devoluciones económicas a cliente</span>
                        <div class="flex-grow-1"></div>   
                            <p-tag severity="secondary" *ngIf="countCompensationTransactions>0"  value="{{countCompensationTransactions}} devoluciones" 
                        [ngClass]="{'flex items-center justify-center text-center': true}"/>                          
                    </span>
                </ng-template>
                <div class="flex justify-content-end mb-2">
                    <div class="flex-grow-1"></div>
                    <p-button *ngIf="allowWrite" label="Añadir devolución" styleClass="ml-2" icon="pi pi-plus"
                        (click)="generateCompensation()" />                                 
                </div>
                <p-table styleClass="mt-4" #grid [value]="compensationTransactions" [lazy]="true"
                    [loading]="loadingCompensationTransactions" [paginator]="true" [rows]="25"
                    [totalRecords]="totalCompensationTransactionsRecords" [showCurrentPageReport]="true"
                    currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
                    [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex"
                    paginatorDropdownAppendTo="body">
                    <ng-template pTemplate="header" let-columns>
                        <tr>                            
                            <th pSortableColumn="code">Código <p-sortIcon field="code"></p-sortIcon></th>
                            <th pSortableColumn="date">Fecha <p-sortIcon field="date"></p-sortIcon></th>
                            <th pSortableColumn="transactionState.name">Estado <p-sortIcon
                                    field="transactionState.name"></p-sortIcon></th>                                                        
                            <th pSortableColumn="total">Total <p-sortIcon field="total"></p-sortIcon></th>
                            <th width="100"></th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-transaction let-columns="columns">
                        <tr (dblclick)="editTransaction('client_compensation', transaction)">                            
                            <td>{{transaction.code}}</td>
                            <td>{{transaction.date | date:'dd/MM/yy'}}</td>
                            <td>
                                <span class="p-tag" 
                                        [style.backgroundColor]="transaction.transactionState?.backgroundColor"
                                        [style.color]="transaction.transactionState?.foregroundColor">
                                    <span class="p-tag-label">{{transaction.transactionState?.name}}</span>
                                </span>
                            </td>                            
                            <td>
                                {{transaction.total | currency:'EUR'}}                                
                            </td>
                            <td>
                                <div class="flex gap-2 justify-content-end">                                                                                                        
                                    <!--<p-button *ngIf="allowDelete" (click)="deleteCompensationTransaction(transaction)"
                                        [rounded]="true" [text]="false" severity="danger"><i
                                            class="pi pi-trash"></i></p-button>-->
                                    <p-button *ngIf="allowWrite" (click)="editTransaction('client_compensation', transaction)" [rounded]="true"
                                        [text]="false"><i class="pi pi-pencil"></i></p-button>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage" let-columns>
                        <tr>
                            <td [attr.colspan]="7">
                                No se ha encontrado transacciones
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-accordionTab>
        </p-accordion>
    </div>
</div>

<p-dialog header="Selecciona una fecha de revisión" [(visible)]="displayModal" [modal]="true" [closable]="false"
    [style]="{width: '300px'}">
    <div class="input-field">
        <label for="date">Fecha</label>
        <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="case.revisionDate" [showIcon]="true" [showButtonBar]="true"
            [minDate]="today"
            [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" d-form-field-error
            appendTo="body"></p-calendar>
    </div>

    <ng-template pTemplate="footer">
        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancelHideModal()"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="hideModal()"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Notificaciones" [(visible)]="showNotifications" [modal]="true" [closable]="true">
    <p-table styleClass="mt-4" #grid [value]="notifications"
         [scrollable]="true" scrollHeight="flex">
        <ng-template pTemplate="header" let-columns>
            <tr>
                <th width="100" pSortableColumn="createdAt">Fecha <p-sortIcon field="createdAt"></p-sortIcon></th>
                <th width="180" pSortableColumn="subject">Usuario <p-sortIcon field="user"></p-sortIcon></th>
                <th pSortableColumn="content">Contenido <p-sortIcon field="content"></p-sortIcon></th>                                                
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-notification let-columns="columns">
            <tr [class.notification-unread]="notification.readedAt==null">
                <td>{{notification.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>
                <td>{{notification.user?.name}}</td> 
                <td>
                    {{notification.subject}}<br>
                    <small>{{notification.content}}</small>
                </td>                                
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <button pButton label="Marcar como leídas" icon="pi pi-check" (click)="readNotifications()"></button>        
    </ng-template>
</p-dialog>

<p-confirmDialog></p-confirmDialog>

<p-overlayPanel #phoneOverlayPanel>
    <div class=" flex flex-column gap-2">
        <a (click)="call(phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.callerId, case.id)">Llamar</a>
        <a (click)="sms(phoneOverlayPanelData.phoneNumber, case.id, phoneOverlayPanelData.caseServiceId)">Enviar sms</a>
        <!--<a (click)="whatsapp(phoneOverlayPanelData.phoneNumber, case.id, phoneOverlayPanelData.callerId)">Enviar whatsapp</a>-->
        <a (click)="openWhatsapp(case.id, phoneOverlayPanelData.phoneNumber, phoneOverlayPanelData.callerId)">Chat whatsapp</a>
    </div>
</p-overlayPanel>

<p-dialog header="Eventos pendientes" [(visible)]="showPendingLogsModal" [modal]="true" [closable]="true" [style]="{width: '400px'}">
    Tienes comunicaciones pendientes de revisión. <br> Por favor, revisa dichas comunicaciones en la sección "Eventos". 
    <ng-template pTemplate="footer">
        <button pButton label="Aceptar" icon="pi pi-check" (click)="showPendingLogsModal=false;"></button>        
    </ng-template>
</p-dialog>
<p-dialog header="Devolución económica" [(visible)]="displayCompensationModal" [modal]="true" [closable]="false"
    [style]="{width: '500px'}">
    <div class="grid">
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="compensation.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" [hourFormat]="'24'" d-form-field-error
                appendTo="body"></p-calendar>
        </div>
        <div class="col-6 input-field">
            <label for="price">Precio</label>
            <input [(ngModel)]="compensation.price" pInputText type="number" d-form-field-error (input)="calculatePrices()">
        </div>                
        <div class="col-6 input-field">
            <label for="code">Impuestos(%)</label>
            <p-dropdown [(ngModel)]="compensation.taxPercent" [options]="taxes"
                optionLabel="displayName" optionValue="percent" appendTo="body" filterBy="name"
                placeholder="Seleccione opción" (onChange)="calculatePrices()" d-form-field-error></p-dropdown>                            
            <label class="mt-2">
                {{ compensation.taxAmount | currency:'EUR':'symbol':'1.2-2' }}
            </label>
        </div>
        <div class="col-6 input-field">
            <label for="total">Importe</label>
            <input pInputText type="text" value="{{ compensation.total | currency:'EUR':'symbol':'1.2-2' }}" disabled>
        </div>
        <div class="col-12 input-field">
            <label for="name">Cuenta bancaria</label>
            <p-dropdown name="clientBankAccountId" [options]="clientBankAccounts"
              optionLabel="accountNumber" optionValue="id" [filter]="true" filterBy="accountNumber" [(ngModel)]="compensation.clientBankAccountId"
              placeholder="Seleccione cuenta bancaria" appendTo="body" 
              d-form-field-error />
        </div>
        <div class="col-12 input-field">
            <label for="description">Notas</label>
            <textarea pInputTextarea [(ngModel)]="compensation.notes" style="field-sizing: content;"
                d-form-field-error rows="3"></textarea>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex">
            <button pButton label="Ficha cliente" icon="pi pi-pencil" class="p-button-secondary" (click)="editClientDetail()"></button>
            <div class="flex-grow-1"></div>
            <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayCompensationModal=false"></button>
            <button pButton label="Guardar" icon="pi pi-check" (click)="saveCompensation()"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog header="Declaración de siniestro" [(visible)]="showDeclarationModal" [modal]="true" [closable]="true" [style]="{width: '900px'}">
    <div class="declaration" [innerHtml]="getDeclarationInfo(case.declaration)" ></div>
    <ng-template pTemplate="footer">
        <button pButton label="Aceptar" icon="pi pi-check" (click)="showDeclarationModal=false;"></button>        
    </ng-template>
</p-dialog>

<p-dialog header="Número de servicio relacionado" [(visible)]="displayCaseNotificationNumberModal" [modal]="true" [closable]="false"
    [style]="{width: '500px'}">
    <div class="grid">        
        <div class="col-6 input-field">
            <label for="code">Código *</label>
            <input [(ngModel)]="caseNotificationNumber.code" pInputText d-form-field-error >
        </div> 
        <div class="col-6 input-field">
            <label for="date">Fecha</label>
            <p-calendar [firstDayOfWeek]="1" id="date" [(ngModel)]="caseNotificationNumber.date" [showIcon]="true" [showButtonBar]="true"
                [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" [showTime]="true" [hourFormat]="'24'" d-form-field-error
                appendTo="body"></p-calendar>
        </div>  
        <div class="col-12 input-field">
            <label for="capabilityDescription">Gremio</label>
            <textarea pInputTextarea [(ngModel)]="caseNotificationNumber.capabilityDescription" style="field-sizing: content;"
                d-form-field-error rows="3"></textarea>
        </div>   
        <div class="col-12 input-field">
            <label for="description">Descripción</label>
            <textarea pInputTextarea [(ngModel)]="caseNotificationNumber.description" style="field-sizing: content;"
                d-form-field-error rows="3"></textarea>
        </div>
        <div class="col-6 input-field">
            <label for="state">Estado</label>
            <input [(ngModel)]="caseNotificationNumber.state" pInputText d-form-field-error >
        </div>  
    </div>
    <ng-template pTemplate="footer">        
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="displayCaseNotificationNumberModal=false"></button>
        <button pButton label="Guardar" icon="pi pi-check" (click)="saveCaseNotificationNumber()"></button>
    </ng-template>
</p-dialog>